/* ============================================================================ 
FILE: po-k9-champ-d-or-texts-fr-en-es-20260411.js  (PATCH)
MODE: TwinLang FR/EN/ES via localStorage + lexicon injection
API:  window.PoK9ChampDOrTextsFR_EN_ES_20260411
ROOT: .po-axis-section[data-po-axis]  (ciblage interne par data-po-lex-id)

ROLE:
  - Langue pilotée par localStorage :
      clé principale : po_lex_lang
      clé compat     : goody_gp_lang
    Langues autorisées : fr, en, es.
  - Expose getLang(), setLang(lang), init() et déclenche po:locale-changed.
  - Ré-injecte le contenu trilingue (fallback + lexique si dispo) dans les slots.
  - Écoute po:lexicon-ready pour re-render si le lexique arrive après.
  - Protection fine PRIORITAIRE :
      - verrouille (translate="no") TOUTES les occurrences du lexique simplifié FR canonique
        via meta.lexique_simplifie_fr si disponible (avec variantes '/' + œ/oe)
      - anti-collage (espaces DOM uniquement quand nécessaire)
  - Ajoute/alimente le slot CTA fin de page : data-po-slot="cta_translate" (sans toucher au href/animation).
  - Ajoute une couche audio locale et générale sans toucher à la logique de langue,
    au lexique, aux protections translate="no" ni au nom du fichier.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_K9_CHAMP_D_OR_TEXTS_20260411__) return;
  window.__PO_K9_CHAMP_D_OR_TEXTS_20260411__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";

  var CANON = {
    title: "Champ d’Or",
    field: "Champ d’Or",
    souffle: "Souffle d’Or",
    chant: "Chant d’Or",
    asexel: "Àṣẹxel’Or"
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g,"-");
    if (s === "fr" || s.indexOf("fr") === 0) return "fr";
    if (s === "en" || s.indexOf("en") === 0) return "en";
    if (s === "es" || s.indexOf("es") === 0) return "es";
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    return "fr";
  }

  function setLang(lang){
    var l = storeLang(lang);
    applyLangEverywhere(l);
    notifyLocaleChanged();
    return l;
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}

    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k])  return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k])  return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/\"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta &&
         Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Posœnnoïsme",
      "Système Posœnnoïal",
      "Katûpirsia",
      "Sujet pluriel",
      "Aliœvolution",
      "Néotaxie",
      "RéZonans",
      "Illusion",
      "Synchrêtique",
      "Synchrêtisme",
      "Addition synchrêtique",
      "L’Addition Synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives"
    ];
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    var terms = [];
    var seen = Object.create(null);

    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "fallback";
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        key = "meta:" + window.PO_LEXICON_META.lexique_simplifie_fr.length;
      }else if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        key = "meta2:" + window.PO_LEXICON.meta.lexique_simplifie_fr.length;
      }
    }catch(e){ key = "fallback"; }

    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last){
        frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      }

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : "";
            if (pn === "SCRIPT" || pn === "STYLE") return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return String(html); }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return "";
    return "<p>" + escapeHTML(s).replace(/\n+/g, "</p><p>") + "</p>";
  }

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:"", lang:"fr", voice:null };
  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ return getTargetBlocks(); }
  function getDetailBlocks(root){ return root ? Array.prototype.slice.call(root.querySelectorAll(".po-lex-details") || []) : []; }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i=0;i<btns.length;i++) if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];
    var title = detail.querySelector(".po-lex-summary__title") || detail.querySelector(".po-lex-summary");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);
    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);
    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = "";
    for (var i=0;i<pieces.length;i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      if (((current ? current + " " : "") + piece).length > 220){
        if (current) out.push(current.trim());
        if (piece.length > 220){
          var words = piece.split(/\s+/);
          var acc = "";
          for (var j=0;j<words.length;j++){
            var w = words[j];
            if (!w) continue;
            var next = acc ? (acc + " " + w) : w;
            if (next.length > 220){
              if (acc) out.push(acc.trim());
              acc = w;
            }else acc = next;
          }
          current = acc || "";
        }else current = piece;
      }else current = current ? (current + " " + piece) : piece;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function getVoices(){ try{ return PO_AUDIO_SYNTH ? (PO_AUDIO_SYNTH.getVoices() || []) : []; }catch(e){ return []; } }
  function pickVoiceForLang(lang){
    var voices = getVoices();
    if (!voices.length) return null;
    var target = normLang(lang);
    var targets = (target === "fr") ? ["fr", "fr-fr", "fr_ca", "fr-ca"] : (target === "en") ? ["en", "en-us", "en-gb"] : ["es", "es-es", "es-mx", "es-us"];
    var i, v, vl;
    for (i=0;i<voices.length;i++){ v = voices[i]; vl = clampStr(v.lang).toLowerCase(); if (targets.indexOf(vl) !== -1) return v; }
    for (i=0;i<voices.length;i++){ v = voices[i]; vl = clampStr(v.lang).toLowerCase(); if (vl.indexOf(target) === 0) return v; }
    return voices[0] || null;
  }
  function getSpeechLangCode(lang){ var L = normLang(lang); if (L === "en") return "en-US"; if (L === "es") return "es-ES"; return "fr-FR"; }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles";
    style.textContent = ".po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid currentColor;background:transparent;color:inherit;padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;line-height:1.2;transition:opacity .2s ease,transform .2s ease;}" +
      ".po-axis-audio-btn:hover{transform:translateY(-1px);}" +
      ".po-axis-audio-btn[aria-pressed='true']{font-weight:600;}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;}" +
      "@media (max-width:640px){.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("translate", "yes");
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");
        var generalBtn = createAudioButton("general");
        generalWrap.appendChild(generalBtn);
        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling); else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else panel.appendChild(generalWrap);
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    var activeRoot = (PO_AUDIO_STATE.root === root);
    var activeKey = PO_AUDIO_STATE.activeKey;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = btn.getAttribute("data-po-audio-role") || "detail";
      var idx = parseInt(btn.getAttribute("data-po-audio-index"), 10);
      var key = (role === "general") ? "general" : ("detail:" + (isNaN(idx) ? -1 : idx));
      var isActive = activeRoot && activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending);
      btn.textContent = isActive ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    }
  }

  function openDetailForPlayback(detail){
    if (!detail) return;
    try{ if (typeof detail.open !== "undefined") detail.open = true; }catch(e){}
    try{ detail.setAttribute("open", "open"); }catch(_e){}
  }

  function stopAudio(){
    try{ if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    var roots = getAudioRoots();
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.voice = null;
    PO_AUDIO_STATE.lang = getLang();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], getLang());
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === "general"){
      units.push({ role:"general", index:-1 });
      for (var i=0;i<details.length;i++) units.push({ role:"detail", index:i });
      return units;
    }
    var start = (typeof index === "number" && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++) units.push({ role:"detail", index:j });
    return units;
  }

  function getTextForUnit(root, unit){
    if (!root || !unit) return "";
    if (unit.role === "general") return collectGeneralText(root);
    var details = getDetailBlocks(root);
    var detail = details[unit.index];
    if (!detail) return "";
    openDetailForPlayback(detail);
    return collectDetailText(detail);
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      playCurrentUnit(true);
      return;
    }
    var chunk = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!chunk){ speakNextChunk(); return; }
    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = getSpeechLangCode(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.rate = 1; utter.pitch = 1;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ speakNextChunk(); }
  }

  function playCurrentUnit(fromNext){
    if (!PO_AUDIO_STATE.root) return;
    if (!fromNext && PO_AUDIO_STATE.unitPos < 0) PO_AUDIO_STATE.unitPos = 0;
    if (fromNext) PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){ stopAudio(); return; }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    var text = getTextForUnit(PO_AUDIO_STATE.root, unit);
    var chunks = splitTextForSpeech(text);
    if (!chunks.length){ playCurrentUnit(true); return; }
    PO_AUDIO_STATE.chunks = chunks;
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = (unit.role === "general") ? "general" : ("detail:" + unit.index);
    refreshAudioLabels(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){ stopAudio(); return; }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  var FALLBACK = {
    fr: {
      title: "Champ d’Or",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 - Àṣẹxel’Or</em><br />(Grammaire dorée, lecture systémique et poïétique du <span class='po-lex-protect' translate='no'>Souffle d’Or</span>)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Champ et structures dorés"],
      chip_urls: ["https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Champ_d_or.png?v=1773256935", "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Champs_d_or_fonctionnel.png?v=1773256936", "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/champs_et_structures_dores.png?v=1773257097"],
      def_short: "Matrice lumineuse où s’articulent les lois du 3–6–9, Champ d’Or désigne l’espace de syntonie dans lequel le Souffle règle forme, mémoire, conscience et geste créateur.",
      def_long: "Dans le corpus du Katûpirsia 9, Champ d’Or / Champ doré est défini comme une matrice lumineuse où s’articulent les lois du 3–6–9. Il relève de la grammaire dorée de K9, au sein de laquelle la forme X d’Or nomme un principe, un organe ou un opérateur de cohérence.\n\nChamp d’Or agit comme un espace de syntonie : il accueille la respiration du Souffle d’Or, met en relation lumière, mémoire, matière et conscience, puis rend cette relation praticable dans un champ sensible. Là, le nombre cesse d’être pure mesure pour devenir clarté opérative, et la proportion devient rythme habitable.\n\nDans la lecture systémique intégrée du Katûpirsia 9, Champ d’Or appartient au plan poïétique et créatif, aux côtés de Modulation dorée et de Chant d’Or. Il désigne le lieu où le geste créateur cesse d’être simple production pour devenir résonance du Souffle.\n\nÀ l’échelle de l’œuvre, du rite, du texte ou de l’espace vécu, Champ d’Or constitue donc une surface d’accord : il distribue les intensités, tient les écarts, oriente la forme et laisse apparaître une cohérence respirante entre le visible et l’invisible.",
      h_features: "Caractéristiques opératives",
      h_questions: "Questions-guides",
      hint_fold: "déplier",
      example_title: "Ex.",
      example: "Composer une œuvre, une phrase, un rite ou un dispositif où lumière, mémoire, espace et cadence se règlent ensemble jusqu’à produire une cohérence respirante.",
      features: ["Matrice lumineuse : Champ d’Or articule les lois du 3–6–9 dans un espace de syntonie.", "Opérateur poïétique : dans K9, il accueille la Modulation dorée et prépare le passage vers Chant d’Or.", "Champ de cohérence : il relie forme, mémoire, conscience et geste au sein du Souffle d’Or.", "Surface d’inscription : il rend praticable une respiration commune entre matière, lumière et temps."],
      questions: ["Quel champ suis-je en train d’ouvrir : perception, mémoire, forme, relation ou rite ?", "Quel réglage rend ce champ habitable : cadence, densité, silence, espacement ou orientation ?", "Quelle trace du Souffle devient lisible ici : rayonnement, retenue, reprise ou diffusion ?", "À quel moment le champ bascule-t-il vers le geste créateur, et donc vers Chant d’Or ?"],
      h_family: "Écosystème doré",
      family_1: "<p><strong>Grammaire dorée :</strong> dans K9, la forme <span class='po-lex-protect' translate='no'>X d’Or</span> nomme ce qui agit comme principe, organe ou opérateur de cohérence. <span class='po-lex-protect' translate='no'>Champ d’Or</span> appartient à cette famille d’opérateurs, aux côtés de <span class='po-lex-protect' translate='no'>Souffle d’Or</span> et de <span class='po-lex-protect' translate='no'>Mémoire d’Or</span>.</p>",
      family_2: "<p><strong>Voisinages actifs :</strong> <a href='https://goodyart.store/pages/asexelor'>Àṣẹxel’Or</a>, <a href='https://goodyart.store/pages/souffle-d-or'>Souffle d’Or</a>, <a href='https://goodyart.store/pages/chant-d-or'>Chant d’Or</a>, <a href='https://goodyart.store/pages/mesure-d-or'>Mesure d’Or</a>, <a href='https://goodyart.store/pages/architecture-d-or'>Architecture d’Or</a>.</p>",
      h_wordbuild: "Construction et portée",
      word_blocks: [{"head": "1) Champ — espace d’apparition", "text": "Désigne l’étendue sensible, opérative et relationnelle où quelque chose peut se tenir, se moduler et devenir lisible."}, {"head": "2) d’Or — opérateur de cohérence", "text": "Dans la grammaire dorée de K9, la forme X d’Or nomme un principe ou un organe de cohérence plutôt qu’une simple qualité décorative."}, {"head": "3) Champ d’Or — espace de syntonie", "text": "Le corpus le définit comme la matrice lumineuse où s’articulent les lois du 3–6–9, c’est-à-dire un champ où le Souffle distribue les rapports justes."}, {"head": "4) Portée poïétique", "text": "Dans la lecture systémique intégrée, Champ d’Or appartient au plan poïétique et créatif : le geste y devient résonance du Souffle."}],
      word_notes: ["Grammaire dorée K9 : X d’Or = principe / organe / opérateur ; Or de X = phase / état ; X doré(e) = qualité / support.", "Formes attestées dans le corpus : Champ d’Or / Champ doré ; la forme canonique de l’entrée demeure Champ d’Or.", "Image associée attestée : « Champ et structures dorés »."],
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: "Champ d’Or",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 - Àṣẹxel’Or</em><br />(Golden grammar, systemic reading, and poïetic reading of <span class='po-lex-protect' translate='no'>Souffle d’Or</span>)",
      h_def: "Operative definition",
      chips: ["Concept ideogram", "Functional ideogram", "Champ et structures dorés"],
      chip_urls: ["https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Champ_d_or.png?v=1773256935", "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Champs_d_or_fonctionnel.png?v=1773256936", "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/champs_et_structures_dores.png?v=1773257097"],
      def_short: "A luminous matrix in which the laws of 3–6–9 are articulated, Champ d’Or names the space of syntony where the breath regulates form, memory, consciousness, and the creative gesture.",
      def_long: "Within the corpus of Katûpirsia 9, Champ d’Or / Champ doré is defined as a luminous matrix where the laws of 3–6–9 are articulated. It belongs to the golden grammar of K9, in which the form X d’Or names a principle, an organ, or an operator of coherence.\n\nChamp d’Or acts as a space of syntony: it receives the breathing of Souffle d’Or, sets light, memory, matter, and consciousness into relation, then makes that relation practicable within a sensible field. Here, number ceases to be mere measure and becomes operative clarity, while proportion becomes a habitable rhythm.\n\nIn the integrated systemic reading of Katûpirsia 9, Champ d’Or belongs to the poïetic and creative plane, alongside Modulation dorée and Chant d’Or. It names the place where the creative gesture ceases to be mere production and becomes resonance of the breath.\n\nAt the scale of the artwork, the rite, the text, or the lived space, Champ d’Or therefore functions as a surface of accord: it distributes intensities, holds intervals, orients form, and lets a breathing coherence appear between the visible and the invisible.",
      h_features: "Operative features",
      h_questions: "Guide questions",
      hint_fold: "expand",
      example_title: "Ex.",
      example: "Compose an artwork, a sentence, a rite, or a device in which light, memory, space, and cadence are tuned together until a breathing coherence appears.",
      features: ["Luminous matrix: Champ d’Or articulates the laws of 3–6–9 within a space of syntony.", "Poïetic operator: in K9, it hosts Modulation dorée and prepares the passage toward Chant d’Or.", "Field of coherence: it links form, memory, consciousness, and gesture within Souffle d’Or.", "Surface of inscription: it makes a shared breathing between matter, light, and time practicable."],
      questions: ["Which field am I opening here: perception, memory, form, relation, or rite?", "Which adjustment makes this field habitable: cadence, density, silence, spacing, or orientation?", "Which trace of the breath becomes legible here: radiance, restraint, return, or diffusion?", "At what point does the field tilt toward the creative gesture, and thus toward Chant d’Or?"],
      h_family: "Golden ecosystem",
      family_1: "<p><strong>Golden grammar:</strong> in K9, the form <span class='po-lex-protect' translate='no'>X d’Or</span> names what acts as a principle, organ, or operator of coherence. <span class='po-lex-protect' translate='no'>Champ d’Or</span> belongs to this family of operators, alongside <span class='po-lex-protect' translate='no'>Souffle d’Or</span> and <span class='po-lex-protect' translate='no'>Mémoire d’Or</span>.</p>",
      family_2: "<p><strong>Active proximities:</strong> <a href='https://goodyart.store/pages/asexelor'>Àṣẹxel’Or</a>, <a href='https://goodyart.store/pages/souffle-d-or'>Souffle d’Or</a>, <a href='https://goodyart.store/pages/chant-d-or'>Chant d’Or</a>, <a href='https://goodyart.store/pages/mesure-d-or'>Mesure d’Or</a>, <a href='https://goodyart.store/pages/architecture-d-or'>Architecture d’Or</a>.</p>",
      h_wordbuild: "Construction and scope",
      word_blocks: [{"head": "1) Champ — a space of appearance", "text": "Names the sensitive, operative, and relational extent in which something can hold, modulate itself, and become legible."}, {"head": "2) d’Or — an operator of coherence", "text": "In the golden grammar of K9, the form X d’Or names a principle or organ of coherence rather than a merely decorative quality."}, {"head": "3) Champ d’Or — a space of syntony", "text": "The corpus defines it as the luminous matrix where the laws of 3–6–9 are articulated, that is, a field in which the breath distributes just relations."}, {"head": "4) Poïetic scope", "text": "In the integrated systemic reading, Champ d’Or belongs to the poïetic and creative plane: here the gesture becomes resonance of the breath."}],
      word_notes: ["Golden grammar K9: X d’Or = principle / organ / operator; Or de X = phase / state; X doré(e) = quality / support.", "Forms attested in the corpus: Champ d’Or / Champ doré; the canonical entry remains Champ d’Or.", "Associated attested image: “Champ et structures dorés”."],
      cta_translate: "Propose a translation of the concept"
    },
    es: {
      title: "Champ d’Or",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 - Àṣẹxel’Or</em><br />(Gramática dorada, lectura sistémica y lectura poiética de <span class='po-lex-protect' translate='no'>Souffle d’Or</span>)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional", "Champ et structures dorés"],
      chip_urls: ["https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Champ_d_or.png?v=1773256935", "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Champs_d_or_fonctionnel.png?v=1773256936", "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/champs_et_structures_dores.png?v=1773257097"],
      def_short: "Matriz luminosa donde se articulan las leyes del 3–6–9, Champ d’Or nombra el espacio de sintonía en el que el aliento regula forma, memoria, conciencia y gesto creador.",
      def_long: "En el corpus de Katûpirsia 9, Champ d’Or / Champ doré se define como una matriz luminosa donde se articulan las leyes del 3–6–9. Pertenece a la gramática dorada de K9, en la que la forma X d’Or nombra un principio, un órgano o un operador de coherencia.\n\nChamp d’Or actúa como un espacio de sintonía: acoge la respiración de Souffle d’Or, pone en relación luz, memoria, materia y conciencia, y vuelve practicable esa relación dentro de un campo sensible. Aquí el número deja de ser pura medida y se vuelve claridad operativa, y la proporción se vuelve ritmo habitable.\n\nEn la lectura sistémica integrada de Katûpirsia 9, Champ d’Or pertenece al plano poiético y creativo, junto a Modulation dorée y Chant d’Or. Nombra el lugar donde el gesto creador deja de ser mera producción y se vuelve resonancia del aliento.\n\nEn la escala de la obra, del rito, del texto o del espacio vivido, Champ d’Or funciona entonces como una superficie de acuerdo: distribuye intensidades, sostiene intervalos, orienta la forma y deja aparecer una coherencia respirante entre lo visible y lo invisible.",
      h_features: "Características operativas",
      h_questions: "Preguntas-guía",
      hint_fold: "desplegar",
      example_title: "Ej.",
      example: "Componer una obra, una frase, un rito o un dispositivo donde luz, memoria, espacio y cadencia se ajusten juntos hasta producir una coherencia respirante.",
      features: ["Matriz luminosa: Champ d’Or articula las leyes del 3–6–9 dentro de un espacio de sintonía.", "Operador poiético: en K9 acoge Modulation dorée y prepara el paso hacia Chant d’Or.", "Campo de coherencia: enlaza forma, memoria, conciencia y gesto en Souffle d’Or.", "Superficie de inscripción: vuelve practicable una respiración compartida entre materia, luz y tiempo."],
      questions: ["¿Qué campo estoy abriendo aquí: percepción, memoria, forma, relación o rito?", "¿Qué ajuste vuelve habitable este campo: cadencia, densidad, silencio, espaciamiento u orientación?", "¿Qué huella del aliento se vuelve legible aquí: irradiación, contención, retorno o difusión?", "¿En qué momento el campo se inclina hacia el gesto creador y, por tanto, hacia Chant d’Or?"],
      h_family: "Ecosistema dorado",
      family_1: "<p><strong>Gramática dorada:</strong> en K9, la forma <span class='po-lex-protect' translate='no'>X d’Or</span> nombra lo que actúa como principio, órgano u operador de coherencia. <span class='po-lex-protect' translate='no'>Champ d’Or</span> pertenece a esta familia de operadores, junto a <span class='po-lex-protect' translate='no'>Souffle d’Or</span> y <span class='po-lex-protect' translate='no'>Mémoire d’Or</span>.</p>",
      family_2: "<p><strong>Proximidades activas:</strong> <a href='https://goodyart.store/pages/asexelor'>Àṣẹxel’Or</a>, <a href='https://goodyart.store/pages/souffle-d-or'>Souffle d’Or</a>, <a href='https://goodyart.store/pages/chant-d-or'>Chant d’Or</a>, <a href='https://goodyart.store/pages/mesure-d-or'>Mesure d’Or</a>, <a href='https://goodyart.store/pages/architecture-d-or'>Architecture d’Or</a>.</p>",
      h_wordbuild: "Construcción y alcance",
      word_blocks: [{"head": "1) Champ — espacio de aparición", "text": "Nombra la extensión sensible, operativa y relacional en la que algo puede sostenerse, modularse y volverse legible."}, {"head": "2) d’Or — operador de coherencia", "text": "En la gramática dorada de K9, la forma X d’Or nombra un principio u órgano de coherencia más que una cualidad meramente decorativa."}, {"head": "3) Champ d’Or — espacio de sintonía", "text": "El corpus lo define como la matriz luminosa donde se articulan las leyes del 3–6–9, es decir, un campo en el que el aliento distribuye relaciones justas."}, {"head": "4) Alcance poiético", "text": "En la lectura sistémica integrada, Champ d’Or pertenece al plano poiético y creativo: el gesto se vuelve resonancia del aliento."}],
      word_notes: ["Gramática dorada K9: X d’Or = principio / órgano / operador; Or de X = fase / estado; X doré(e) = cualidad / soporte.", "Formas atestiguadas en el corpus: Champ d’Or / Champ doré; la entrada canónica sigue siendo Champ d’Or.", "Imagen asociada atestiguada: « Champ et structures dorés »."],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function fb(lang){ return FALLBACK[lang] || FALLBACK.fr; }
  function normId(raw){ return clampStr(raw).toLowerCase().trim().replace(/_/g,"-"); }

  function isChampDOrBlock(node){
    if (!node || !node.getAttribute) return false;
    var v = normId(node.getAttribute("data-po-lex-id"));
    return (
      v === "champ-d-or" ||
      v === "champ_d_or" ||
      v === "champ d’or" ||
      v === "champ d'or" ||
      v === "champdor" ||
      v === "champ-d-or-fr-en-es" ||
      v === "champ-d-or-texts-fr-en-es-20260411" ||
      v === "k9-champ-d-or" ||
      v === "k9-champdor"
    );
  }

  function getTargetBlocks(){
    var all = document.querySelectorAll(".po-axis-section[data-po-axis]");
    var out = [];
    for (var i=0;i<all.length;i++) if (isChampDOrBlock(all[i])) out.push(all[i]);
    return out;
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
    protectKeywordsInElement(el);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    var s = clampStr(src);
    var a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectKeywordsHTML(escapeHTML(arr[i])) + "</li>");
    el.innerHTML = out.join("");
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='"+slot+"']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = protectKeywordsHTML(escapeHTML(b.head || ""));
      var t = protectKeywordsHTML(escapeHTML(b.text || ""));
      out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + h + '</div><div class="po-axis-wb__t">' + t + '</div></div>');
    }
    host.innerHTML = out.join("");
    protectKeywordsInElement(host);
  }

  function setCTA(root, lang){
    var el = root.querySelector('[data-po-slot="cta_translate"]');
    if (!el) return;
    var txt = (lang === "en") ? "Suggest a translation of the concept" : (lang === "es") ? "Proponer una traducción del concepto" : "Proposer une traduction du concept";
    el.textContent = txt;
  }

  function renderFromLexicon(root, lang){
    var rawId = root.getAttribute("data-po-lex-id");
    var idNorm = normId(rawId);
    var eField =
      getLexiconEntry(rawId) ||
      getLexiconEntry(idNorm) ||
      getLexiconEntry("champ-d-or") ||
      getLexiconEntry("champ_d_or") ||
      getLexiconEntry("champ d’or") ||
      getLexiconEntry("champ d'or") ||
      null;

    var eSouffle =
      getLexiconEntry("souffle-d-or") ||
      getLexiconEntry("souffle_d_or") ||
      getLexiconEntry("souffle d’or") ||
      getLexiconEntry("souffle d'or") ||
      null;

    var eChant =
      getLexiconEntry("chant-d-or") ||
      getLexiconEntry("chant_d_or") ||
      getLexiconEntry("chant d’or") ||
      getLexiconEntry("chant d'or") ||
      null;

    var eAsexel =
      getLexiconEntry("àṣẹxel’or") ||
      getLexiconEntry("àṣẹxel'or") ||
      getLexiconEntry("asẹxel’or") ||
      getLexiconEntry("asẹxel'or") ||
      getLexiconEntry("asexelor") ||
      null;

    if (!eField && !eSouffle && !eChant && !eAsexel) return false;

    var F = fb(lang);

    var title = (eField ? (pickTerm(eField, "fr")) : "") || CANON.title;
    setSlotText(root, "title", title);
    setSlotImgSrc(root, "title_img", (F.chip_urls && F.chip_urls[0]) ? F.chip_urls[0] : "", title);

    var kicker = "";
    if (eField){
      kicker = clampStr(pickAny(eField, "kicker_" + lang, "")) || clampStr(pickAny(eField, "kicker_fr", ""));
    }
    setSlotHTML(root, "kicker", kicker || F.kicker);

    setSlotText(root, "h_def", F.h_def);
    setSlotText(root, "chip_1", F.chips[0]);
    setSlotText(root, "chip_2", F.chips[1]);
    setSlotText(root, "chip_3", F.chips[2]);
    setSlotImgSrc(root, "chip_1_img", (F.chip_urls && F.chip_urls[0]) ? F.chip_urls[0] : "", F.chips[0]);
    setSlotImgSrc(root, "chip_2_img", (F.chip_urls && F.chip_urls[1]) ? F.chip_urls[1] : "", F.chips[1]);
    setSlotImgSrc(root, "chip_3_img", (F.chip_urls && F.chip_urls[2]) ? F.chip_urls[2] : "", F.chips[2]);

    setSlotText(root, "h_features", F.h_features);
    setSlotText(root, "h_questions", F.h_questions);
    setSlotText(root, "hint_fold", F.hint_fold);
    setSlotText(root, "hint_fold2", F.hint_fold);
    setSlotText(root, "h_family", F.h_family);
    setSlotText(root, "h_wordbuild", F.h_wordbuild);
    setSlotText(root, "hint_fold3", F.hint_fold);

    var defS = (eField ? (pickDefShort(eField, lang) || pickDefShort(eField, "fr")) : "") || F.def_short;
    var defL = (eField ? (pickDefLong(eField, lang) || pickDefLong(eField, "fr")) : "") || F.def_long;
    setSlotText(root, "def_short", defS);
    setSlotHTML(root, "def_long", htmlParagraphize(defL));

    var feats = [];
    var ques = [];
    if (eField){
      feats = pickArray(eField, lang, "characteristics") || [];
      if (!feats.length) feats = pickArray(eField, lang, "features") || [];
      ques = pickArray(eField, lang, "usage_questions") || [];
      if (!ques.length) ques = pickArray(eField, lang, "questions") || [];
    }
    renderListInto(root, "features", feats.length ? feats : F.features);
    renderListInto(root, "questions", ques.length ? ques : F.questions);

    var example = "";
    if (eField) example = clampStr(pickAny(eField, "example_" + lang, "")) || clampStr(pickAny(eField, "example_fr", ""));
    example = example || F.example;
    setSlotHTML(root, "example_box", example ? ("<div><strong>"+escapeHTML(F.example_title)+"</strong> " + escapeHTML(example) + "</div>") : "");

    var fam1 = "";
    var fam2 = "";
    if (eSouffle){
      var d1 = pickDefLong(eSouffle, lang) || pickDefLong(eSouffle, "fr") || pickDefShort(eSouffle, lang) || pickDefShort(eSouffle, "fr");
      if (d1) fam1 = "<p><strong>" + escapeHTML(CANON.souffle) + " :</strong> " + escapeHTML(d1) + "</p>";
    }
    if (eChant){
      var d2 = pickDefLong(eChant, lang) || pickDefLong(eChant, "fr") || pickDefShort(eChant, lang) || pickDefShort(eChant, "fr");
      if (d2) fam2 = "<p><strong>" + escapeHTML(CANON.chant) + " :</strong> " + escapeHTML(d2) + "</p>";
    } else if (eAsexel){
      var d3 = pickDefLong(eAsexel, lang) || pickDefLong(eAsexel, "fr") || pickDefShort(eAsexel, lang) || pickDefShort(eAsexel, "fr");
      if (d3) fam2 = "<p><strong>" + escapeHTML(CANON.asexel) + " :</strong> " + escapeHTML(d3) + "</p>";
    }

    setSlotHTML(root, "family_1", fam1 || F.family_1);
    setSlotHTML(root, "family_2", fam2 || F.family_2);

    renderWordBlocks(root, "wordbuild_blocks", F.word_blocks);
    renderListInto(root, "wordbuild_notes", F.word_notes);
    setCTA(root, lang);
    protectKeywordsInElement(root);
    return true;
  }

  function lexiconLooksReady(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) return true;
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
    }catch(e){}
    return false;
  }

  function applyLangEverywhere(lang){
    lang = normLang(lang);
    storeLang(lang);
    var blocks = getTargetBlocks();
    for (var i=0;i<blocks.length;i++){
      var ok = renderFromLexicon(blocks[i], lang);
      if (!ok){
        var F = fb(lang);
        setSlotText(blocks[i], "title", F.title);
        setSlotImgSrc(blocks[i], "title_img", (F.chip_urls && F.chip_urls[0]) ? F.chip_urls[0] : "", F.title);
        setSlotHTML(blocks[i], "kicker", F.kicker);
        setSlotText(blocks[i], "h_def", F.h_def);
        setSlotText(blocks[i], "chip_1", F.chips[0]);
        setSlotText(blocks[i], "chip_2", F.chips[1]);
        setSlotText(blocks[i], "chip_3", F.chips[2]);
        setSlotImgSrc(blocks[i], "chip_1_img", (F.chip_urls && F.chip_urls[0]) ? F.chip_urls[0] : "", F.chips[0]);
        setSlotImgSrc(blocks[i], "chip_2_img", (F.chip_urls && F.chip_urls[1]) ? F.chip_urls[1] : "", F.chips[1]);
        setSlotImgSrc(blocks[i], "chip_3_img", (F.chip_urls && F.chip_urls[2]) ? F.chip_urls[2] : "", F.chips[2]);
        setSlotText(blocks[i], "h_features", F.h_features);
        setSlotText(blocks[i], "h_questions", F.h_questions);
        setSlotText(blocks[i], "hint_fold", F.hint_fold);
        setSlotText(blocks[i], "hint_fold2", F.hint_fold);
        setSlotText(blocks[i], "h_family", F.h_family);
        setSlotText(blocks[i], "h_wordbuild", F.h_wordbuild);
        setSlotText(blocks[i], "hint_fold3", F.hint_fold);
        setSlotText(blocks[i], "def_short", F.def_short);
        setSlotHTML(blocks[i], "def_long", htmlParagraphize(F.def_long));
        renderListInto(blocks[i], "features", F.features);
        renderListInto(blocks[i], "questions", F.questions);
        setSlotHTML(blocks[i], "example_box", "<div><strong>"+escapeHTML(F.example_title)+"</strong> " + escapeHTML(F.example) + "</div>");
        setSlotHTML(blocks[i], "family_1", F.family_1);
        setSlotHTML(blocks[i], "family_2", F.family_2);
        renderWordBlocks(blocks[i], "wordbuild_blocks", F.word_blocks);
        renderListInto(blocks[i], "wordbuild_notes", F.word_notes);
        setCTA(blocks[i], lang);
        protectKeywordsInElement(blocks[i]);
      }else setCTA(blocks[i], lang);
    }
    initAudioEverywhere(lang);
  }

  function init(){
    applyLangEverywhere(getLang());
    window.addEventListener("po:lexicon-ready", function(){
      __PO_PROTECT_CACHE__.key = "";
      __PO_PROTECT_CACHE__.re = null;
      applyLangEverywhere(getLang());
    });
    if (!lexiconLooksReady()){
      var tries = 0;
      var maxTries = 80;
      var timer = setInterval(function(){
        tries++;
        if (lexiconLooksReady() || tries >= maxTries){
          clearInterval(timer);
          __PO_PROTECT_CACHE__.key = "";
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 100);
    }
  }

  window.PoK9ChampDOrTextsFR_EN_ES_20260411 = { init:init, getLang:getLang, setLang:setLang, normLang:normLang, stopAudio:stopAudio };

  try{
    if (!window.GoodyTwinLang){
      window.GoodyTwinLang = { init:init, getLang:getLang, setLang:setLang };
    }else{
      if (typeof window.GoodyTwinLang.getLang !== "function") window.GoodyTwinLang.getLang = getLang;
      if (typeof window.GoodyTwinLang.setLang !== "function") window.GoodyTwinLang.setLang = setLang;
      if (typeof window.GoodyTwinLang.init !== "function") window.GoodyTwinLang.init = init;
    }
  }catch(e){}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
